/*
 * Handing a link or a file to the device's share sheet, where the browser has one
 * (`navigator.share`): a phone's, Safari's, Chrome's on Windows and ChromeOS. Where it hasn't,
 * nothing offers to share.
 */

/** Whether this browser can hand a link to the device's share sheet. */
export const canShare = () => typeof navigator.share === "function"

/** Hands `url` to the device's share sheet, titled `title`. Dismissing the sheet is no failure. */
export const shareLink = (title: string, url: string) =>
  void navigator.share({ title, url }).catch(() => undefined)

/** Whether this browser can hand a photo itself to the device's share sheet, not only a link. */
export const canShareFiles = () =>
  canShare() &&
  typeof navigator.canShare === "function" &&
  navigator.canShare({ files: [new File([], "photo.jpg", { type: "image/jpeg" })] })

/**
 * Hands `file` to the device's share sheet. Dismissing the sheet is no failure; anything else (the
 * browser refusing this file, or the tap that asked having expired) rejects, for the caller to
 * offer the file another way.
 */
export const shareFile = (file: File) =>
  navigator.share({ files: [file] }).catch((error: unknown) => {
    if (error instanceof DOMException && error.name === "AbortError") return
    throw error
  })
